import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import loader from '../../images/Loader.gif';
import { LoaderStyles as classes } from './LoaderStyles';
import { LOADER_ALT_MSG } from '../../constants';

const Loader = ({ dimension }) => (
  <div data-testid="loader_id">
    <Box
      component="img"
      src={loader}
      sx={{ ...classes.loader_circle, ...(dimension && { width: dimension, height: dimension }) }}
      alt={LOADER_ALT_MSG}
    />
  </div>
);
Loader.propTypes = {
  dimension: PropTypes.string,
};

export default Loader;
